import CustomerCareLocaleKeys from '../../../../locales/keys';
import { PAYMENT_METHOD_STATUSES, SUPPORTED_PAYMENT_INSTRUMENT_TYPES } from '../ewallet.constants';
import { getFormattedExpirationForCard, paymentTypeNameIdentifier } from '../ewallet.helpers';
function EwalletListItemController() {
  var _this = this;
  this.$onInit = function () {
    _this.localeKeys = CustomerCareLocaleKeys;
    _this.getFormattedExpirationForCard = getFormattedExpirationForCard;
    _this.paymentTypeNameIdentifier = paymentTypeNameIdentifier;
  };
  this.handleClick = function () {
    _this.onItemSelected()(_this.paymentMethod);
  };
  this.getLineOneTextForItem = function () {
    var paymentMethod = _this.paymentMethod;
    if (_this.isCreditCard()) {
      return paymentMethod.Name || "".concat(paymentMethod.CreditCard.typeName, " - ").concat(paymentMethod.CreditCard.AccountNumber);
    }
    if (_this.isExternalGiftCard()) {
      return paymentMethod.Name || paymentMethod.ExternalGiftCard.typeName;
    }
    if (_this.isGooglePlay()) {
      return paymentMethod.TypeName;
    }
    if (_this.isPayPal() && paymentMethod.PayPalAccount && paymentMethod.PayPalAccount.UserName) {
      return paymentMethod.PayPalAccount.UserName;
    }
    if (_this.isItunes() && paymentMethod.ITunesAccount && paymentMethod.ITunesAccount.UserName) {
      return paymentMethod.ITunesAccount.UserName;
    }
    if (paymentMethod.ExternalBill) {
      return "".concat(paymentMethod.TypeName, " ").concat(paymentMethod.Name);
    }
    return paymentMethod.Name || paymentMethod.TypeName;
  };
  this.isCreditCard = function () {
    return _this.paymentMethod.Type.toString() === SUPPORTED_PAYMENT_INSTRUMENT_TYPES.CREDIT_CARD;
  };
  this.isCurrencyEntitlement = function () {
    return _this.paymentMethod.Type.toString() === SUPPORTED_PAYMENT_INSTRUMENT_TYPES.CURRENCY_ENTITLEMENT;
  };
  this.isInternalGiftCard = function () {
    return _this.paymentMethod.Type.toString() === SUPPORTED_PAYMENT_INSTRUMENT_TYPES.INTERNAL_GIFT_CARD;
  };
  this.isExternalGiftCard = function () {
    return _this.paymentMethod.Type.toString() === SUPPORTED_PAYMENT_INSTRUMENT_TYPES.EXTERNAL_GIFT_CARD;
  };
  this.isPayPal = function () {
    return _this.paymentMethod.Type.toString() === SUPPORTED_PAYMENT_INSTRUMENT_TYPES.PAY_PAL;
  };
  this.isItunes = function () {
    return _this.paymentMethod.Type.toString() === SUPPORTED_PAYMENT_INSTRUMENT_TYPES.ITUNES;
  };
  this.isGooglePlay = function () {
    return _this.paymentMethod.Type.toString() === SUPPORTED_PAYMENT_INSTRUMENT_TYPES.GOOGLE_PLAY;
  };
  this.isStoredValueAccount = function () {
    return _this.paymentMethod.Type.toString() === SUPPORTED_PAYMENT_INSTRUMENT_TYPES.STORED_VALUE_ACCOUNT;
  };
  this.isRemovedOrSuspended = function () {
    return _this.paymentMethod.Status === PAYMENT_METHOD_STATUSES.REMOVED || _this.paymentMethod.Status === PAYMENT_METHOD_STATUSES.SUSPENDED;
  };
}
export default {
  template: require('./ewallet.list.item.html'),
  bindings: {
    paymentMethod: '<',
    isSelectedItem: '<',
    onItemSelected: '&'
  },
  controller: EwalletListItemController,
  controllerAs: 'EwalletListItemController'
};